//   ownerType = {
//     'I': 'Institutional',
//     'G': 'Government',
//     'C': 'Corporate',
//     'T': 'Think5Whys'
//   };

// eventCategory = {
//     'O': 'Open',
//     'S': 'School',
//     'U': 'Undergraduate',
//     'G': 'Graduate',
//     'P': 'Professional'
//   };

//   eventParticipantType = {
//     'I': 'Singles',
//     'D': 'Doubles',
//     'T': 'Team'
//   };
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import MainLayout from '../../../layouts/MainLayout';
import '../styles/MCQPractice.css';
import '../styles/ThinkleticsTables.css';
import { useSelector } from 'react-redux';
import Loader from '../../../components/utils/Loader';
import Tooltip from '../../../components/utils/Tooltip';
import { GenerateThinkleticsEventEnrollmentNumber, GenerateThinkleticsTeamCode } from '../../../components/GenerateThink5whysCode';
// import { getUserByThink5whysCode } from '../../../../../backend/controllers/userDataControllers';
import TINTOC2024 from '../../../assets/pageimages/sponsors/thinkletics/TINTOC2024.png';

const ThinkleticsDashboard = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [isAcceptChecked, setIsAcceptChecked] = useState(false);
    const [eventId, setEventId] = useState('');
    const [eventCode, setEventCode] = useState('');
    const [eventTitle, setEventTitle] = useState('');
    const [eventDRT, setEventDRT] = useState('');

    const [eventMasterList, setEventMasterList] = useState([]);
    const [userEventsList, setUserEventsList] = useState([]);
    const [eventPointsList, setEventPointsList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState('');
    const [userData, setUserData] = useState(null);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [pairCode, setPairCode] = useState('');
    const [teamCode, setTeamCode] = useState('');
    const [newTeamCode, setNewTeamCode] = useState('');
    const [newTeamName, setNewTeamName] = useState('');

    const [userPairCode, setUserPairCode] = useState('');
    const [userTeamCode, setUserTeamCode] = useState('');
    const [userNewTeamCode, setUserNewTeamCode] = useState('');
    const [userPairName, setUserPairName] = useState('');
    const [userTeamName, setUserTeamName] = useState('');
    const [hasPointRulesClicked, setHasPointRulesClicked] = useState(false);
    const [hasGetUserDataClicked, setHasGetUserDataClicked] = useState(false);
    const [hasEnrolledClicked, setHasEnrolledClicked] = useState(false);
    const [hasEnrollInDefaultClicked, setHasEnrollInDefaultClicked] = useState(false);
    const [hasEnrollInDefault, setHasEnrollInDefault] = useState(false);
    const [baseBookId, setBaseBookId] = useState("66210d4517580762a8fd47f0");
    const [defaultEvent, ssetDefaultEvent] = useState("668a20621185ba3591eed7ce");
    const [hasBaseBookPurchased, setHasBaseBookPurchased] = useState(false);
    const [hasAddOnEnrollClicked, setHasAddOnEnrollClicked] = useState(false);
    const [hasEnrollSubmitClicked, setHasEnrollSubmitClicked] = useState(false);
    const [thinkleticsUserAccountCreated, setThinkleticsUserAccountCreated] = useState(false);
    const [hasGetMyThinkleticsDataClicked, setHasGetMyThinkleticsDataClicked] = useState(false);
    const [isDefaultEventFoundInUsersEventList, setIsDefaultEventFoundInUsersEventList] = useState(false);

    const [isSelectedEventFoundInUsersEventList, setIsSelectedEventFoundInUsersEventList] = useState(false);
    const enrollmentNumber = GenerateThinkleticsEventEnrollmentNumber();

    const [error, setError] = useState(null);

    const [userRank, setUserRank] = useState(null);
    const [top20Users, setTop20Users] = useState([]);
    const [buttonUserRankDisabled, setButtonUserRankDisabled] = useState(false);

    const [pairRank, setPairRank] = useState(null);
    const [combinedTotalPoints, setCombinedTotalPoints] = useState(null);
    const [top20Pairs, setTop20Pairs] = useState([]);
    const [buttonPairRankDisabled, setButtonPairRankDisabled] = useState(false);

    const [teamRank, setTeamRank] = useState(null);
    const [top20Teams, setTop20Teams] = useState([]);
    const [buttonTeamRankDisabled, setButtonTeamRankDisabled] = useState(false);
    const [teamCreationStatus, setTeamCreationStatus] = useState(false);
    const [teamCreationStatusMsg, setTeamCreationStatusMsg] = useState('');
    // const [teamCreationButtonClicked, setTeamCreationButtonClicked] = useState(false);
    const [buttonAddTeamDisabled, setButtonAddTeamDisabled] = useState(false);    
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [pairAddonFee, setPairAddonFee] = useState(0);
    const [teamMemberAddonFee, setTeamMemberAddonFee] = useState(0);
    const [walletBalanceAmount, setWalletBalanceAmount] = useState(0);

    const [eventIsSponsored, setEventIsSponsored] = useState(false);
    const [eventSponsorName, setEventSponsorName] = useState('');
    const [eventSponsorMsg, setEventSponsorMsg] = useState('');


     const handleAboutThinkleticsClick = () => {
        navigate('/aboutthinkletics');
    };

    const handleGetMyThinkleticsDataClick = () => {
        setHasGetMyThinkleticsDataClicked(true);
        fetchEventMasterData();
        fetchEventPointsList();
        fetchCheckBaseBookPurchased(baseBookId);
        fetchUserEventsList(userId);
    };

    const fetchEventMasterData = useCallback(() => {
        const config = {
            url: "/thinkleticsmaster/active",
            method: "get",
            headers: { Authorization: authState.token },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("setEventMasterList Response:", response);

                if (Array.isArray(response)) {
                    setEventMasterList(response);
                    setEventDRT(response[0].eventDRT);
                } else {
                    console.error("Invalid response format: Thinkletics Events not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Thinkletics Events:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchEventMasterData();
    }, [authState.isLoggedIn, fetchEventMasterData]);

    const fetchEventPointsList = useCallback(() => {
        const config = {
            url: "/thinkleticspoints",
            method: "get",
            headers: { Authorization: authState.token },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("setEventPointsList:", response);
                if (Array.isArray(response)) {
                    setEventPointsList(response);
                } else {
                    console.error("Invalid response format: Thinkletics Event Points not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Thinkletics Event Points:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchEventPointsList();
    }, [authState.isLoggedIn, fetchEventPointsList]);

    const fetchUserEventsList = useCallback((userId) => {
        const config = {
            url: "/thinkleticsusers/eventslistbyuser",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("setUserEventsList:", response);
                if (response && Array.isArray(response.userdata)) {
                    // console.log("Inside");
                    setUserEventsList(response.userdata);
                    // setIsSelectedEventFoundInUsersEventList(true);
                    const defaultEventFound = response.some(event => event.eventCode === defaultEvent);
                    // console.log("defaultEventFound ", defaultEventFound ? "Yes" : "No");
                    setIsDefaultEventFoundInUsersEventList(defaultEventFound);
                } else {
                    setError("You are not enrolled in any champioship event");
                    console.error("Thinkletics User Events not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Thinkletics User Events:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchUserEventsList(userId);
    }, [authState.isLoggedIn, fetchUserEventsList]);

    const handleEventSelectionChange = (e) => {
        const selectedEventCode = e.target.value;
        // console.log("selectedEventCode",selectedEventCode);
        setSelectedEvent(e.target.value);

        const selectedEvent = userEventsList.find(event => event._id === selectedEventCode);
        const selectedEvenId = selectedEvent.eventId;
        // console.log("selectedEvent pairAddonFee ",selectedEvenId);
        const selectedEventMaster = eventMasterList.find(eventmaster => eventmaster._id === selectedEvenId);

        // console.log("selectedEventMaster  ",selectedEventMaster);

        if (selectedEvent) {
          setEventId(selectedEventMaster._id); 
          setEventCode(selectedEventMaster.eventCode);
          setEventTitle(selectedEventMaster.eventTitle);
          setEventIsSponsored(selectedEventMaster.isSponsored);
          setEventSponsorName(selectedEventMaster.sponsorName);
          setEventSponsorMsg(selectedEventMaster.sponsorMsg);
          setPairAddonFee(selectedEventMaster.pairAddonFee);
          setTeamMemberAddonFee(selectedEventMaster.teamMemberAddonFee);
        } else {
          setEventId(''); 
        }
      };

    const handleGetUserDataClick = () => {
        if (!authState.isLoggedIn) return;
        setHasGetUserDataClicked(true);
        // console.log("Selected Event: ", selectedEvent);
        setEventId(selectedEvent);
    };

    const fetchUserData = useCallback(() => {
        const config = {
            url: "/thinkleticsusers/userdata",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId }
        };
        // console.log("Request Payload for fetching User Data is here: ", config);

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response:", response);
                // console.log("xxxx Response setUserData is here:", response);
                // console.log("xxxx response.data setUserData is here:", response.data);
                // console.log("xxxx response.data.userdata setUserData is here:", response.data.userdata);
                // console.log("xxxx response.userdata setUserData is here:", response.userdata);


                if (response && response.status) {
                    // console.log("xxxx response.userdata setUserData is here:", response.userdata);

                    const {
                        userId,
                        userName,
                        userCode,
                        userPairCode,
                        userTeamCode,
                        userPairName,
                        userTeamName
                    } = response.userdata;
    
                    setUserData(response.userdata);
                    setUserCode(userCode || '');
                    setUserPairCode(userPairCode || '');
                    setUserTeamCode(userTeamCode || '');
                    setUserName(userName || '');
                    setUserPairName(userPairName || '');
                    setUserTeamName(userTeamName || '');
                } else {
                    console.error("Thinkletics User Data not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Thinkletics User Data:", error);
            });
    }, [authState.token, fetchData, userId, setUserData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchUserData();
    }, [authState.isLoggedIn, fetchUserData]);

    const handleEnrollClick = () => {
        setHasEnrolledClicked(true);
    };

    const handleAddOnEnrollClick = () => {
        setHasAddOnEnrollClicked(prevState => !prevState);
    };

    const handleEnrollInDefaultClick = () => {
        setHasEnrollInDefaultClicked(true);
        // console.log("calling fetchCheckBaseBookPurchased with Base Book ID ", baseBookId);
        activateDefault();
        // fetchCheckBaseBookPurchased(baseBookId);
    };

    const fetchCheckBaseBookPurchased = useCallback((baseBookId) => {
        // console.log("Sending Base Book ID ", baseBookId);
        const config = {
            url: "/mybooks/bookidbyuserpurchasestatus",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: baseBookId, userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response:", response, " ", response.status);
                if (response && response.status) {
                    // console.log("response.bookstatus.length:", response.bookstatus.length);
                    if (response.bookstatus.length > 0) {
                        // console.log("setting setHasBaseBookPurchased(true)");
                        setHasBaseBookPurchased(true);
                        // console.log("Activating default from fetchCheckBaseBookPurchased  --- ");
                        // activateDefault();
                    } else {
                        // console.log("setting setHasBaseBookPurchased(false)");
                        setHasBaseBookPurchased(false);
                    }
                } else {
                    console.error("Thinkletics User Base Book Data not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Thinkletics User Base Book Data:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchCheckBaseBookPurchased();
    }, [authState.isLoggedIn, fetchCheckBaseBookPurchased]);

    const activateDefault = async () => {
        // console.log("Activate default calling");
        const requestData = {
            userId: authState.user._id,
            userCode: authState.user.think5whyscode,
            dateCreated: new Date(),
            creationRemarks: 'Enrolled For International Open For All Single Thinkletics',
            totalPoints: 30,
            eventId: "668a20621185ba3591eed7ce",
            eventCode: "TOS2024",
            eventTitle: "Thinkletics Open Singles Championship 2024",
            enrollmentNumber: enrollmentNumber,
            enrollmentDate: new Date(),
            enrollmentPoints: 10,
            enrollmentRemarks: 'Enrolled successfully',
            gotBookCollection: false,
            purchaseDate: null,
            purchasePoints: 20,
            purchaseRemarks: "",
            assignmentCountSyncDate: null,
            assignmentCount: 0,
            assignmentPointForEach: 10,
            assignmentPoints: 0,
            assignmentRemarks: '',
            practiceMCQCountSyncDate: null,
            practiceMCQCount: 0,
            practiceMCQPointForEach: 0,
            practiceMCQPoints: 0,
            practiceMCQRemarks: '',
            certificateNumber: '',
            certificateDate: null,
            certificationTestPoints: 0,
            certificationTestRemarks: '',
            registrationNumber: '',
            registrationDate: null,
            thinkleticsMasterCode: 'THK123',
            registrationPoints: 0,
            registrationRemarks: '',
            rcaEntryCountSyncDate: null,
            rcaEntryCount: 0,
            rcaEntryPointsForEach: 0,
            rcaEntryPoints: 0,
            rcaEntryRemarks: '',
            lcEntryCountSyncDate: null,
            lcEntryCount: 0,
            lcEntryPointsForEach: 0,
            lcEntryPoints: 0,
            lcEntryRemarks: '',
            rcaLCLinkEntryCountSyncDate: null,
            rcaLCLinkEntryCount: 0,
            rcaLCLinkEntryPointsForEach: 0,
            rcaLCLinkEntryPoints: 0,
            rcaLCLinkEntryRemarks: '',
            vbEntryCountSyncDate: null,
            vbEntryCount: 0,
            vbEntryPointsForEach: 0,
            vbEntryPoints: 0,
            vbEntryRemarks: '',
            povifyEntryCountSyncDate: null,
            povifyEntryCount: 0,
            povifyEntryPointsForEach: 0,
            povifyEntryPoints: 0,
            povifyEntryRemarks: '',
            bookPageReadCountSyncDate:null,
            bookPageReadCount: 0,
            bookPageReadPointsForEach: 0,
            bookPageReadPoints: 0,
            bookPageReadRemarks: '',
            spotSnapCountSyncDate: null,
            spotSnapCount: 0,
            spotSnapPointsForEach: 0,
            spotSnapPoints: 0,
            spotSnapRemarks: '',
            focusTimerCountSyncDate: null,
            focusTimerCount: 0,
            focusTimerPointsForEach: 0,
            focusTimerPoints: 0,
            focusTimerRemarks: '',
            bookBuyCountSyncDate: null,
            bookBuyCount: 0,
            bookBuyPoints: 0,
            bookBuyRemarks: "",
            bookGiftingCountSyncDate: null,
            bookGiftingCount: 0,
            bookGiftingPoints: 0,
            bookGiftingRemarks: "",
            isActive: true,
            isDeleted: false,
            msgForUser: 'Keep up the good work!',
            remarks: 'Excellent progress',
            userName: userName,
            userPairName: '',
            userTeamName: '',
            userPairCode: '',
            userTeamCode: '',
            pairingDate: null,
            bookId: "66210d4517580762a8fd47f2",
            bookCollectionId: null,
        };
        // console.log('Thinkletics new user default enrollment data to be saved:', requestData);
        try {
            const config = {
                url: `/thinkleticsusers`,
                method: "post",
                data: { userData: requestData },
                headers: { Authorization: authState.token }
            };
            await fetchData(config);
            // console.log('setThinkleticsUserAccountCreated:', setThinkleticsUserAccountCreated ? "Yes" : "No");
            setThinkleticsUserAccountCreated(true);
            // console.log('setThinkleticsUserAccountCreated:', setThinkleticsUserAccountCreated ? "Yes" : "No");
        } catch (error) {
            console.error('An error occurred while creating Thinkletics Default Event User Account:', error);
        }
    };

    const handleSubmitClick = () => {
        setHasEnrollSubmitClicked(true);
        enrollInNew();
    };

    const handleShowPointRulesClick = () => {
        setHasPointRulesClicked(prevState => !prevState);
    };


    const enrollInNew = async () => {
        const requestData = {
            userId: authState.user._id,
            userCode: authState.user.think5whyscode,
            dateCreated: new Date(),
            creationRemarks: 'Initial creation',
            totalPoints: 0,
            enrollmentNumber: enrollmentNumber,
            enrollmentDate: new Date(),
            enrollmentPoints: 20,
            enrollmentRemarks: 'Enrolled successfully',
            gotBookCollection: false,
            purchaseDate: null,
            purchasePoints: 30,
            purchaseRemarks: "",
            assignmentCountSyncDate: null,
            assignmentCount: 0,
            assignmentPointForEach: 10,
            assignmentPoints: 0,
            assignmentRemarks: '',
            practiceMCQCountSyncDate: null,
            practiceMCQCount: 0,
            practiceMCQPointForEach: 0,
            practiceMCQPoints: 0,
            practiceMCQRemarks: '',
            certificateNumber: '',
            certificateDate: null,
            certificationTestPoints: 0,
            certificationTestRemarks: '',
            registrationNumber: '',
            registrationDate: null,
            thinkleticsMasterCode: 'THK2024',
            registrationPoints: 0,
            registrationRemarks: '',
            rcaEntryCountSyncDate: null,
            rcaEntryCount: 0,
            rcaEntryPointsForEach: 0,
            rcaEntryPoints: 0,
            rcaEntryRemarks: '',
            lcEntryCountSyncDate: null,
            lcEntryCount: 0,
            lcEntryPointsForEach: 0,
            lcEntryPoints: 0,
            lcEntryRemarks: '',
            rcaLCLinkEntryCountSyncDate: null,
            rcaLCLinkEntryCount: 0,
            rcaLCLinkEntryPointsForEach: 0,
            rcaLCLinkEntryPoints: 0,
            rcaLCLinkEntryRemarks: '',
            vbEntryCountSyncDate: null,
            vbEntryCount: 0,
            vbEntryPointsForEach: 0,
            vbEntryPoints: 0,
            vbEntryRemarks: '',
            povifyEntryCountSyncDate: null,
            povifyEntryCount: 0,
            povifyEntryPointsForEach: 0,
            povifyEntryPoints: 0,
            povifyEntryRemarks: '',
            bookPageReadCountSyncDate:null,
            bookPageReadCount: 0,
            bookPageReadPointsForEach: 0,
            bookPageReadPoints: 0,
            bookPageReadRemarks: '',
            spotSnapCountSyncDate: null,
            spotSnapCount: 0,
            spotSnapPointsForEach: 0,
            spotSnapPoints: 0,
            spotSnapRemarks: '',
            focusTimerCountSyncDate: null,
            focusTimerCount: 0,
            focusTimerPointsForEach: 0,
            focusTimerPoints: 0,
            focusTimerRemarks: '',
            bookBuyCountSyncDate: null,
            bookBuyCount: 0,
            bookBuyPoints: 0,
            bookBuyRemarks: "",
            bookGiftingCountSyncDate: null,
            bookGiftingCount: 0,
            bookGiftingPoints: 0,
            bookGiftingRemarks: "",
            isActive: true,
            isDeleted: false,
            msgForUser: 'Keep up the good work!',
            remarks: 'Excellent progress',
            userName: userName,
            userPairName: '',
            userTeamName: '',
            userPairCode: '',
            userTeamCode: '',
            pairingDate: null,
            bookId: "66210d4517580762a8fd47f2",
            bookCollectionId: null,
        };
        // console.log('Thinkletics new user data to be saved:', requestData);
        try {
            const config = {
                url: `/thinkleticsusers`,
                method: "post",
                data: { userData: requestData },
                headers: { Authorization: authState.token }
            };
            await fetchData(config);
            // setThinkleticsUserAccountCreated(true);
        } catch (error) {
            console.error('An error occurred while creating Thinkletics User Account:', error);
        }
    };

    const formattedDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const handleUserRankButtonClick = async () => {
        setButtonUserRankDisabled(true);
        const config = {
            url: "/thinkleticsusers/getuserrank",
            method: "post",
            headers: { Authorization: authState.token  },
            data: { eventId: userData.eventId, userCode: userData.userCode }
        };
        // console.log("Request Payload for fetching user rank: ", userData.eventId, userData.userCode );

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("User Rank: ",response);
                // console.log("User Rank: ",response);
                // console.log("User Rank List: ",response.rankList);
                if (response && response.status) {
                    const { top20Users, rankList } = response;
                    setUserRank(response.userRank);
                    setTop20Users(response.rankList);
                } else {
                    console.error("Error fetching rank:", response.msg);
                    // Handle error case here if needed
                }
            })
            .catch(error => {
                console.error("Error fetching rank:", error);
                // Handle error case here if needed
            });
    };

    const handlePairRankButtonClick = async () => {
        setButtonPairRankDisabled(true);
        const config = {
            url: "/thinkleticsusers/getpairrank",
            method: "post",
            headers: { Authorization: authState.token  },
            data: { eventId: userData.eventId, userCode: userData.userCode, userPairCode: userData.userPairCode }
        };
        // console.log("Request Payload for fetching pair rank: ", userData.eventId, userData.userCode, userData.userPairCode );

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("pair Rank: ",response.pairRank);
                // console.log("pair combinedTotalPoints: ",response.combinedTotalPoints);
                // console.log("pair Rank List: ",response.top20Pairs);
                if (response && response.status) {
                    const { pairRank, combinedTotalPoints, top20Pairs } = response;
                    setPairRank(response.pairRank);
                    setCombinedTotalPoints(response.combinedTotalPoints);
                    setTop20Pairs(response.top20Pairs);
                } else {
                    console.error("Error fetching pair rank:", response.msg);
                    // Handle error case here if needed
                }
            })
            .catch(error => {
                console.error("Error fetching pair rank:", error);
                // Handle error case here if needed
            });
    };

    const [buttonAddPairDisabled, setButtonAddPairDisabled] = useState(false);
    const [addPairStatus, setAddPairStatus] = useState(false);
    const handleAddPairButtonClick = async () => {
        setButtonAddPairDisabled(true);
        // console.log("User Data Request Payload for adding pair: ",userData);
        const pairingDate = new Date();
        const config = {
            url: `/thinkleticsusers/addpair/${userData._id}`,
            method: "put",
            headers: { Authorization: authState.token  },
            data: { userId: authState.user._id, userPairCode: userPairCode, userPairName: userPairName, pairingDate: pairingDate, paymentAmount: paymentAmount }
        };
        // console.log("Request Payload for adding pair: ", userData.userId, userPairCode, userPairCode, pairingDate, paymentAmount );

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Request Payload for adding pair: ",response);

                if (response && response.status) {
                    setAddPairStatus(true);
                    setPaymentAmount(pairAddonFee);

                } else {
                    console.error("Error adding pair: ", response.msg);
                    // Handle error case here if needed
                }
            })
            .catch(error => {
                console.error("Error adding pair: ", error);
                // Handle error case here if needed
            });
    };


    const handleTeamRankButtonClick = async () => {
        setButtonTeamRankDisabled(true);
        const config = {
            url: "/thinkleticsusers/getteamrank",
            method: "post",
            headers: { Authorization: authState.token  },
            data: { eventId: eventId, userTeamCode: userData.userTeamCode }
        };
        // console.log("Request Payload for fetching team rank: ", eventId, userData.userTeamCode);

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && response.status) {
                    setTeamRank(response.teamRank);
                    setCombinedTotalPoints(response.teamPoints);
                    setTop20Teams(response.top20Teams);
                } else {
                    console.error("Error fetching team rank:", response.msg);
                    // Handle error case here if needed
                }
            })
            .catch(error => {
                console.error("Error fetching team rank:", error);
                // Handle error case here if needed
            });
    };
    
    const [createPairClicked, setCreatePairClicked] = useState(false);
    const handleCreatePairClick  = () => {
        setCreatePairClicked(true);
        // console.log("pairAddonFee",pairAddonFee);
        setPaymentAmount(pairAddonFee);
        fetchWalletBalance();
    };

    const pairCodeValidationClicked = (pairCode) => {
        if (/^TU[a-zA-Z0-9]{12}$/.test(pairCode)) {
            if (userCode === pairCode) {
                setError("You cannot be self paired. Please use a different valid user code than yours.");
            } else {
                fetchPairCodeForThinkletics(pairCode);
                // console.log("Fetching Referrer Code for User Event");
            }
        } else {
            setError('Please enter a valid 14-character Pair Code starting with TU.');
        }
    };

const [pairCodeStatus, setPairCodeStatus] = useState(false);
const [pairCodeStatusMsg, setPairCodeStatusMsg] = useState('');
const fetchPairCodeForThinkletics = useCallback((pairCode) => {
        // console.log("pairCode for API call ", pairCode, " User Data...",userData);
        const config = {
            url: "/thinkleticsusers/checkpair",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userCode: pairCode, eventId: userData.eventId }
        };
        // console.log("Request Payload for check pair code in fetchPairCodeForThinkletics: ", pairCode,userData.eventId ); 

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("Pair Code found ", response);
                    setPairCodeStatus(true);
                    setUserPairCode(response.pairUser.userCode);
                    setUserPairName(response.pairUser.userName);
                    setPairCodeStatusMsg(`Pair Code ${pairCode} found for this Event! 😊`);
                } else {
                    // console.log("pairCode Not found");
                    setPairCodeStatus(false);
                    setPairCodeStatusMsg(`Pair Code ${pairCode} for this event not found! 😔 Make sure the Pair Code is enrolled in this event.`);
                }
            })
            .catch(error => {
                // console.log("pairCode Not found!");
                setPairCodeStatus(false);
                setPairCodeStatusMsg(`Pair Code ${pairCode} for this event not found! 😔 Make sure the Pair Code is enrolled in this event.`);
            });
    }, [fetchData, setPairCodeStatus, userData]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchPairCodeForThinkletics]);


    const [createTeamClicked, setCreateTeamClicked] = useState(false);
    const handleCreateTeamButtonClick  = () => {
        // console.log("handleCreateTeamButtonClick");
        setCreateTeamClicked(true);
        const newTeamCode = GenerateThinkleticsTeamCode();
        // console.log("handleCreateTeamButtonClick");
        setUserNewTeamCode(newTeamCode);
        // teamCreationValidationClicked(newTeamCode, newTeamName, userId, eventId);
    };

    const teamCreationValidationButtonClicked = (userNewTeamCode, newTeamName, userId, eventId) => {
        if (newTeamName=='') {
            setError('Team Name Can not be blank');
        } else {
            // console.log("Fetching Team Code for Validation");
            saveNewThinkleticsTeamCode(userNewTeamCode, newTeamName, userId, eventId);
        }
    };

    const [buttonAddNewTeamDisabled, setButtonAddNewTeamDisabled] = useState(false);
    const [addNewTeamStatus, setAddNewTeamStatus] = useState(false);
    const [addNewTeamStatusMsg, setAddNewTeamStatusMsg] = useState(false);

    const saveNewThinkleticsTeamCode = async (userNewTeamCode, newTeamName, userId, eventId) => {
        setButtonAddNewTeamDisabled(true);
        const teamCreationDate = new Date(); 
        const config = {
            url: `/thinkleticsusers/addteam/${userData._id}`,
            method: "put",
            headers: { Authorization: authState.token  },
            data: { teamCreatorName:userData.userName, userTeamCode: userNewTeamCode, userTeamName: newTeamName, userId: userId, teamMethod: "Created", teamJoiningDate: teamCreationDate}
        };
        // console.log("Request Payload for creating team: ", userData.userName, userData._id, userNewTeamCode, newTeamName, userId, eventId, teamCreationDate );

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response for creating team: ",response);

                if (response && response.status) {
                    // console.log("inside response ");

                    setAddNewTeamStatus(true);
                    setAddNewTeamStatusMsg("Your Thinkletics Competition Team Is Created. Now You Can Ask Others To Join Your Thinkletics Team Using Your Team Code");
                } else {
                    console.error("Error creating team: ", response.msg);
                    setAddNewTeamStatus(false);
                    setAddNewTeamStatusMsg("Error! in creating your Thinkeltics Competition Team. Please retry.");
                }
            })
            .catch(error => {
                console.error("Error creating team: ", error);
                // Handle error case here if needed
            });
    };


    const [joinTeamClicked, setJoinTeamClicked] = useState(false);
    const handleJoinTeamClick  = () => {
        setJoinTeamClicked(true);
        // console.log("team member Join fee ",teamMemberAddonFee);

        setPaymentAmount(teamMemberAddonFee);
        fetchWalletBalance();
    };

    const teamCodeValidationClicked = (teamCode, userEventId) => {
        if (/^TL[a-zA-Z0-9]{12}$/.test(teamCode)) {
            // console.log("Fetching Team Code for Validation");
            fetchTeamCodeForThinkletics(teamCode, userEventId);
        } else {
            setError('Please enter a valid 14-character Team Code starting with TL.');
        }
    };

    const [teamCodeStatus, setTeamCodeStatus] = useState(false);
    const [teamCodeStatusMsg, setTeamCodeStatusMsg] = useState('');
    const [userTeamRecordId, setUserTeamRecordId] = useState('');
    const [teamCreatorName, setTeamCreatorName] = useState('');

    const fetchTeamCodeForThinkletics = useCallback((teamCode, userEventId) => {
        // console.log("teamCode for API call ", teamCode,userEventId);
        const config = {
            url: "/thinkleticsusers/checkteam",
            method: "post",
            headers: { Authorization: authState.token },
            data: { teamCode: teamCode, eventId: userEventId }
        };
        // console.log("Request Payload for check team code in fetchTeamCodeForThinkletics: ", teamCode, userEventId); 

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("Team Code found ", response);
                    setTeamCodeStatus(true);
                    setUserTeamRecordId(response.team._id);
                    setUserTeamCode(response.team.userTeamCode);
                    setUserTeamName(response.team.userTeamName);
                    setTeamCreatorName(response.team.userName);
                    setTeamCodeStatusMsg(`Team: ${response.team.userTeamCode} Titled: ${response.team.userTeamName} found for the competition which is created by ${response.team.userName}! 😊`);
                } else {
                    // console.log("Team Code Not found");
                    setTeamCodeStatus(false);
                    setTeamCodeStatusMsg(`Team Code ${teamCode} for this event not found! 😔 Make sure the Team Code is created for this event by the originator.`);
                }
            })
            .catch(error => {
                // console.log("Team Code Not found!");
                setTeamCodeStatus(false);
                setTeamCodeStatusMsg(`Team Code ${teamCode} for this event not found! 😔 Make sure the Team Code is created for this event by the originator.`);
            });
    }, [fetchData, setPairCodeStatus, setUserTeamName, setTeamCreatorName, setUserTeamRecordId, setUserTeamCode   ]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchTeamCodeForThinkletics]);

    const [buttonJoinTeamDisabled, setButtonJoinTeamDisabled] = useState(false);
    const handleJoinTeamButtonClick  = () => {
        setButtonJoinTeamDisabled(true);
        joinThinkleticsTeam(userTeamCode, userTeamName, userId, eventId)
    };

const [joinTeamStatus, setJoinTeamStatus] = useState(false);
const [joinTeamStatusMsg, setJoinTeamStatusMsg] = useState('');
const joinThinkleticsTeam = async (userTeamCode, userTeamName, userId, eventId) => {
    const teamJoiningDate = new Date();    
    const config = {
            url: `/thinkleticsusers/jointeam/${userData._id}`,
            method: "put",
            headers: { Authorization: authState.token  },
            data: { userName: authState.user.name, userTeamCode: userData.userTeamCode, userTeamName: userData.userTeamName, userId: userId, teamMethod: "Joined", teamCreatorName: teamCreatorName, teamJoiningDate: teamJoiningDate, paymentAmount: paymentAmount}
        };
        // console.log("Request Payload for joining team: ", config);

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response for joining team: ",response);

                if (response && response.status) {
                    // console.log("inside userdata ", userData);
                    setJoinTeamStatus(true);
                    setPaymentAmount(teamMemberAddonFee);
                    setJoinTeamStatusMsg("Your have joined Thinkletics Competition Team ${response.userTeamName} created by ${response.teamCreatorName}.");
                } else {
                    console.error("Error joining team: ", response.msg);
                    setJoinTeamStatus(false);
                    setJoinTeamStatusMsg("Error! in joining your Thinkeltics Competition Team ${userTeamName}. Please retry.");
                }
            })
            .catch(error => {
                console.error("Error joining team: ", error);
                // Handle error case here if needed
            });
    };

const handleNavigateToThinkleticsDataSyncClick = () => {
    navigate(`/thinkletics-updatepoints`, { state: { userData: userData} });
};
    
const [buttonAssignmentCountDisabled, setButtonAssignmentCountDisabled] = useState(false);
const handleAssignmentCountClick  = () => {
    setButtonAssignmentCountDisabled(true);
    fetchAssignmentCount();
};

const [assignmentCount, setAssignmentCount] = useState(0);
const [assignmentCountMsg, setAssignmentCountMsg] = useState('');
const fetchAssignmentCount = async () => {
    const today=new Date();
    const fromDate= userData.dateCreated;
    const config = {
            url: "/assignment/countbydaterange",
            method: "post",
            headers: { Authorization: authState.token  },
            data: { user: userData.userId, fromDate: fromDate, toDate: today}
        };
        // console.log("Request Payload for /assignment/countbydaterange: ",userData.userId, fromDate, today );

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response for /assignment/countbydaterange: ",response);

                if (response && response.status) {
                    // console.log("inside /assignment/countbydaterange ", response.assignmentCount);
                    setAssignmentCount(response.assignmentCount);
                    setAssignmentCountMsg("Successfully fetched assignment count.");
                    updateAssignmentCount(userData._id,response.assignmentCount);
                } else {
                    console.error("Error In Assignment Count: ", response.msg);
                    setAssignmentCountMsg("Error! fetching assignment count.");
                }
            })
            .catch(error => {
                console.error("Error! fetching assignment count: ", error);
            });
    };

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchAssignmentCount]);

    const updateAssignmentCount = async (_id,assignmentCount) => {
        const assignmentCountSyncDate = new Date();
        const config = {
                url: `/thinkleticsusers/updateassignmentcount/${userData._id}`,
                method: "put",
                headers: { Authorization: authState.token  },
                data: { assignmentCount: assignmentCount, assignmentCountSyncDate: assignmentCountSyncDate }
            };
            // console.log("Request Payload for /thinkleticsusers/updateassignmentcount: ",_id, assignmentCount, assignmentCountSyncDate );
    
            fetchData(config, { showSuccessToast: false })
                .then(response => {
                    // console.log("response for /thinkleticsusers/updateassignmentcount: ",response);
    
                    if (response && response.status) {
                        // console.log("inside /thinkleticsusers/updateassignmentcount ", response.status);
                    } else {
                        console.error("Error In Updating Assignment Count: ", response.msg);
                    }
                })
                .catch(error => {
                    console.error("Error! Updating Assignment Count: ", error);
                });
        };
    
        useEffect(() => {
            if (!authState.isLoggedIn) return;
        }, [authState.isLoggedIn, updateAssignmentCount]);

const [buttonMCQPracticeCountDisabled, setButtonMCQPracticeCountDisabled] = useState(false);
const handleMCQPracticeCountClick  = () => {
    setButtonMCQPracticeCountDisabled(true);
    fetchMCQCount();
};


const [updateCertificateInfoDisabled, setUpdateCertificateInfoDisabled] = useState(false);
const handleUpdateCertificateInfoClick  = () => {
    setUpdateCertificateInfoDisabled(true);
    fetchCertificateInfo();
};

const [updateRCAEntryCountDisabled, setUpdateRCAEntryCountDisabled] = useState(false);
const handleUpdateRCAEntryCountClick  = () => {
    setUpdateRCAEntryCountDisabled(true);
    fetchUpdateRCACount();
};

const [updateLCEntryCountDisabled, setUpdateLCEntryCountDisabled] = useState(false);
const handleUpdateLCEntryCountClick  = () => {
    setUpdateLCEntryCountDisabled(true);
    fetchUpdateLCCount();
};

const [updateBookPageReadCountDisabled, setUpdateBookPageReadCountDisabled] = useState(false);
const handleUpdateBookPageReadCountClick  = () => {
    setUpdateBookPageReadCountDisabled(true);
    fetchUpdateBookPageReadCount();
};

const [updateRCALCLinkCountDisabled, setUpdateRCALCLinkCountDisabled] = useState(false);
const handleUpdateRCALCLinkCountClick  = () => {
    setUpdateRCALCLinkCountDisabled(true);
    fetchUpdateLCCount();
};

const [updateSpotSnapCountDisabled, setUpdateSpotSnapCountDisabled] = useState(false);
const handleUpdateSpotSnapCountClick  = () => {
    setUpdateSpotSnapCountDisabled(true);
    fetchUpdateSpotSnapCount();
};

const [updateFocusTimerCountDisabled, setUpdateFocusTimerCountDisabled] = useState(false);
const handleUpdateFocusTimerCountClick  = () => {
    setUpdateFocusTimerCountDisabled(true);
    fetchUpdateFocusTimerCount();
};

const [updateVBCountDisabled, setUpdateVBCountDisabled] = useState(false);
const handleUpdateVBCountClick  = () => {
    setUpdateVBCountDisabled(true);
    fetchUpdateVBCount();
};

const [updatePovifyCountDisabled, setUpdatePovifyCountDisabled] = useState(false);
const handleUpdatePovifyCountClick  = () => {
    setUpdatePovifyCountDisabled(true);
    fetchUpdatePovifyCount();
};

const [updateBookBuyCountDisabled, setUpdateBookBuyCountDisabled] = useState(false);
const handleUpdateBookBuyCountClick  = () => {
    setUpdateBookBuyCountDisabled(true);
    fetchUpdateBookBuyCount();
};

const [updateBookGiftCountDisabled, setUpdateBookGiftCountDisabled] = useState(false);
const handleUpdateBookGiftCountClick  = () => {
    setUpdateBookGiftCountDisabled(true);
    fetchUpdateBookGiftCount();
};




// Wallet Section APIs Call
const handleRechargeWallet = () => {
    navigate('/wallet-topup', { state: { userId: userData.userId, addOnType: "P", amount: paymentAmount}});
};

//WalletBalance
const fetchWalletBalance = useCallback(() => {
    const config = {
        url: "/walletbalance",
        method: "get",
        headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            // console.log("Wallet Balance Response:", response);
            if (response) {
                // console.log("Wallet Balance Response in array:", response);
                setWalletBalanceAmount(response.balanceAmount);
            } else {
                console.error("Invalid response format: Wallet not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching wallet master:", error);
            setWalletBalanceAmount(0);
        });
}, [authState.token, fetchData]);

useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
}, [authState.isLoggedIn, fetchWalletBalance]);

const handleAcceptCheckboxChange = (event) => {
    setIsAcceptChecked(event.target.checked);
};

const [showTerms, setShowTerms] = useState(false);
const toggleTerms = () => {
    setShowTerms(!showTerms);
};

return (
    <MainLayout>
        <div className="min-h-full py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-8">
            <h2 className='text-3xl font-bold text-white text-center mb-6'>Thinkletics - OneView</h2>
            <div className='text-white mt-4 '>
                <div className="flex justify-center">
                    <button
                        type="button"
                        className="bg-orange-600 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark mr-2"
                        onClick={handleAboutThinkleticsClick}
                    >
                        About Thinkletics
                    </button>
                    <button
                        type="button"
                        className="bg-green-600 text-white mr-2 py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={handleGetMyThinkleticsDataClick}
                        disabled={hasGetMyThinkleticsDataClicked}
                    >
                        Get My Thinkletics Data
                    </button>
                    <button
                        type="button"
                        className="bg-blue-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={handleAddOnEnrollClick}
                    >
                        Enroll In Add-On Events
                    </button>
                </div>
            </div>
            {hasAddOnEnrollClicked && (
                <>
                {/* <div className='text-xl mb-2 text-center text-yellow-300'>
                    <p>Currently There is no add-on Events active for Enrollment. We will get back with more Events soon.</p>
                </div> */}
                <div className='mb-8 text-center'>
                    <p className='text-m text-yellow-400 bg-purple-600 py-2 mb-2'>All Upcoming / Current Events List</p>
                    {eventMasterList.map((eventmaster, index) => (
                        <p 
                        key={eventmaster.id} 
                        className={eventmaster.isLive ? 'bg-green-500 text-white border-b' : 'bg-gray-500 text-white border-b'}
                        >
                            {index + 1}. {eventmaster.eventTitle}
                        </p>
                    ))}
                </div>
                </>
            )}
            {hasGetMyThinkleticsDataClicked && (
                <>
                    {hasBaseBookPurchased ? (
                        <>
                            <div>
                                <p className="mb-4 text-m bg-green-800 text-center text-white">Great!! You have purchased The Think5whys - Book 1 Main BOK (Body of Knowledge Book).</p>
                            </div>
                            {userEventsList.length > 0 ? (
                                <>
                                    {userEventsList.length > 0 ? (
                                        <div className="flex justify-center">
                                            <select
                                                name="eventSelection"
                                                id="eventSelection"
                                                value={selectedEvent}
                                                onChange={handleEventSelectionChange}
                                                className="h-12 text-center p-2 border border-gray-300 bg-gray-100 text-gray-700 rounded"
                                            >
                                                <option value="">Select Your Enrolled Event</option>
                                                {userEventsList.map(userevent => (
                                                    <option key={userevent._id} value={userevent._id}>
                                                        {userevent.eventTitle}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <p></p>
                                    )}
                                </>
                            ) : (
                                <div className="mb-4">
                                    <div>
                                        <p className="mb-4 text-xl text-orange-500 text-center"><strong>But</strong> you have yet not Activated Your <strong>Thinkletics International Open Single Championship Event</strong>!!</p>
                                    </div>
                                    <div className='mb-4 flex justify-center'>
                                        <input
                                            type="checkbox"
                                            id="agree"
                                            checked={isAcceptChecked}
                                            onChange={handleAcceptCheckboxChange}
                                            className='mr-2'
                                        />
                                        <label htmlFor="agree" className='text-sm'>
                                            I abide by 
                                            <span 
                                                className='text-blue-500 underline cursor-pointer'
                                                onClick={toggleTerms}
                                            >
                                                Thinkletics Rules, Terms of Use and disclaimer
                                            </span>.
                                            I hereby accept it for my enrollment in the event.
                                        </label>
                                    </div>
                                    {showTerms && (
                                        <div className=' bg-gray-500 bg-opacity-75 flex justify-center items-center z-50'>
                                            <div className='bg-white text-blue-800 text-sm mt-4 ml-4 mr-4 mb-4'>
                                                <div className='mt-4 ml-4 mr-4 mb-4' dangerouslySetInnerHTML={{ __html: eventDRT }} />
                                                <div className='p-8 rounded-lg relative max-w-lg mx-auto'>
                                                    <button
                                                        onClick={toggleTerms}
                                                        className='absolute top-2 right-2 text-white hover:text-gray-300'
                                                    >
                                                        Close
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div>
                                        <button
                                            type="button"
                                            className="bg-blue-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={handleEnrollInDefaultClick}
                                            disabled={hasEnrollInDefaultClicked || !isAcceptChecked}
                                        >
                                            Activate Your Thinkletics International Open Single Championship Event Now
                                        </button>
                                        {hasEnrollInDefaultClicked && (
                                            <>
                                                {thinkleticsUserAccountCreated ? (
                                                    <div>
                                                        <p className="mb-4 text-xl text-yellow-400 text-center">Your Account is Now Activated for International Open Single Thinkletics Event. <strong className='text-xl'>Your Event Enrollment Number is {enrollmentNumber}</strong></p>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <p className="mb-4 text-xl text-red-800 text-center">Sorry!! Error in Activated your Account for International Open Single Thinkletics Event!! Try Again.</p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className='text-xl text-yellow-300 text-center flex flex-justify'>
                                <button
                                    type="button"
                                    className="bg-blue-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark mr-8"
                                    onClick={handleGetUserDataClick}
                                    disabled={hasGetUserDataClicked || userEventsList.length === 0 || selectedEvent === ''}
                                >
                                    Show My Data
                                </button>
                                <button
                                    type="button"
                                    className="bg-blue-500 text-gray-200 py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                    onClick={handleShowPointRulesClick}
                                >
                                    {hasPointRulesClicked ? "Hide Thinkletics Point Rules" : "Show Thinkletics Point Rules"}
                                </button>
                            </div>
                            {hasGetUserDataClicked && eventIsSponsored &&(
                                <div className='ml-4 text-white'>
                                    <div className='flex justify-center'>
                                        <p><strong>This Event is Sponsored By</strong></p>
                                    </div>
                                    <div className='flex justify-center'>
                                        <p className='text-xl text-purple-400'><strong>{eventSponsorName}</strong></p>
                                    </div>
                                    <div className='flex justify-center'>    
                                        <p style={{ wordWrap: 'break-word', textAlign: 'center' }}>Sponsor's Message To You: <strong>{eventSponsorMsg}</strong></p>                                    </div>
                                    <div className='flex justify-center'>
                                        <p className='mt-4 text-yellow-400'>
                                            <img src={TINTOC2024} />
                                        </p>  
                                    </div>  
                                </div>
                            )}
                            {hasPointRulesClicked && (
                                <div className='text-center'>
                                    <p className='text-yellow-200 bg-purple-800 text-xl w-full'>Point Rules</p>
                                    {eventPointsList.length === 0 ? (
                                        <p className='text-red-500 text-xl'>There is No Points List For Selected Event!!</p>
                                    ) : (
                                        eventPointsList.map((pointslist, index) => (
                                            <div key={index} className=' border-b text-left ml-4 mr-4 mb-1 justify-start'>
                                                {index==0 && (
                                                    <p className="text-yellow-400 bg-blue-700 w-full border-b py-2 mt-4">Championship / Event Qualification Steps</p>
                                                )}
                                                {index==6 && (
                                                    <p className="text-yellow-400 bg-blue-700 w-full border-b">Ongoing Accumulation After Registering in Championship / Event </p>
                                                )}
                                                <p className={index < 6 ? 'text-orange-400' : 'text-yellow-400'}>
                                                    {index < 6 ? `Step ${pointslist.eventStep}: ${pointslist.eventAction}` : `${pointslist.eventAction}`}
                                                </p>
                                                <p className='text-white'>Points To be earned: {pointslist.eventActionPoints}</p>
                                                <p className='text-white'>Points Earning Rule: {pointslist.eventActionPointsRule}</p>
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}
                            {hasGetUserDataClicked && (
                                <div className='ml-4 text-white'>
                                    <div className='mb-4'>   
                                        <div className='flex justify-center'>
                                            <p><strong>User:</strong>{authState.user.name}</p>
                                        </div>
                                        <div className='flex justify-center'>
                                            <p><strong>[User Code :</strong> {userData.userCode}]</p>
                                        </div>
                                        <div className='flex justify-center'>
                                            <p className='mt-4 text-yellow-400'>
                                                <strong>Think5Whys - Book 1 (Main BOK)</strong>
                                            </p>  
                                        </div>  
                                        <div className='flex justify-center'>
                                            <p className='mb-4 text-yellow-400'>
                                                In Book Shelf Since: {formattedDateTime(userData.dateCreated)}
                                            </p>
                                        </div>
                                        <div className='flex justify-center items-center'>
                                            <p className='text-white'><strong>Your Enrollment#:</strong> {userData.enrollmentNumber}</p>
                                        </div>
                                        <div className='flex justify-center'>
                                            <p className='text-white'><strong >Date Enrolled:</strong> {formattedDateTime(userData.enrollmentDate)}</p>
                                        </div>
                                    </div> 
                                    <div className='mb-4 w-10/12 mx-auto'>
                                        <table className="responsive-table">
                                            <thead>
                                            <tr>
                                                <th>Action</th>
                                                <th>Points Earned</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className='text-yellow-200'>Total Points</td>
                                                <td className='text-yellow-200'><strong >{userData.totalPoints}</strong></td>
                                            </tr>
                                            <tr>
                                                <td>1. Activation Points</td>
                                                <td>{userData.enrollmentPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>2. Purchase Points</td>
                                                <td>{userData.purchasePoints}</td>
                                            </tr>
                                            <tr>
                                                <td>3. Assignment Points</td>
                                                <td>{userData.assignmentPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>4. Practice MCQ Points</td>
                                                <td>{userData.practiceMCQPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>5. Certification Test Points</td>
                                                <td>{userData.certificationTestPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>6. Event Qualification Points</td>
                                                <td>{userData.registrationPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>7. RCA Entry Points</td>
                                                <td>{userData.rcaEntryPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>8. LC Entry Points</td>
                                                <td>{userData.lcEntryPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>9. RCA LC Link Entry Points</td>
                                                <td>{userData.rcaLCLinkEntryPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>10. Book Page Read Points</td>
                                                <td>{userData.bookPageReadPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>11. Spot Snap Points</td>
                                                <td>{userData.spotSnapPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>12. Focus Timer Points</td>
                                                <td>{userData.focusTimerPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>13. VisualBrief</td>
                                                <td>{userData.vbEntryPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>14. POVify</td>
                                                <td>{userData.povifyEntryrPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>15. Book Buy Points</td>
                                                <td>{userData.bookBuyPoints}</td>
                                            </tr>
                                            <tr>
                                                <td>16. Book Gifting Points</td>
                                                <td>{userData.bookGiftingPoints}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='mb-2 text-center text-lg text-white'>
                                        <p><strong>{userData.msgForUser}</strong></p>
                                    </div>
                                    <div className='mb-2'>
                                        <div className='flex justify-center'>
                                            <button
                                                onClick={handleUserRankButtonClick}
                                                disabled={buttonUserRankDisabled}
                                                className='px-4 py-2 bg-green-800 text-white rounded'
                                            >
                                                Click to View Your Rank
                                            </button>
                                        </div>
                                        {buttonUserRankDisabled && top20Users !== null && (
                                            <>
                                            <div className='flex justify-center'>
                                                <p className='text-2xl text-yellow-300'><strong>Your Rank:</strong> {userRank}</p>
                                            </div>
                                            <div className='flex justify-center'>
                                                <p className='text-xl mb-4'>Top {top20Users.length} User Rank List</p>
                                            </div>    
                                            <div className='mt-4'>
                                                <div className='overflow-x-auto'>
                                                    <table className='min-w-full bg-blue-400'>
                                                        <thead>
                                                            <tr>
                                                                <th className='py-2'>Rank</th>
                                                                <th className='py-2'>User Code</th>
                                                                <th className='py-2'>User Name</th>
                                                                <th className='py-2'>Total Points</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {top20Users.map((user, index) => (
                                                                <tr key={index}>
                                                                    <td className='py-2'>{user.userRank}</td>
                                                                    <td className='py-2'>{user.userCode}</td>
                                                                    <td className='py-2'>{user.userName}</td>
                                                                    <td className='py-2'>{user.totalPoints}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            </>
                                        )}
                                    </div>
                                    <div className='mb-2'>
                                        {userData.userPairCode === '' ? (
                                            <>
                                            <div className='flex justify-center'>
                                                <button
                                                    type="button"
                                                    className="bg-yellow-500 text-white hover:bg-primary-dark"
                                                    onClick={handleCreatePairClick}
                                                >
                                                    Create Your Pair
                                                </button>
                                            </div>
                                            {createPairClicked && (
                                                <>
                                                <div className="text-black bg-blue-400 rounded-lg shadow-lg mb-4 mt-4 ml-4 mr-4">
                                                    {pairAddonFee>0 && (    
                                                        <div className="mt-4 mb-2">
                                                            <div className='mt-4 flex justify-center'>
                                                                <p className='text-orange-800'>Pair Addon Fee to pay: <span>₹{paymentAmount.toFixed(2)}</span></p>
                                                            </div>
                                                            <div className='flex justify-center'>
                                                                <p className='text-orange-800'>Think5Whys Wallet Balance: <span>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                            </div>
                                                            <div className='flex justify-center'>
                                                                {paymentAmount > walletBalanceAmount ? (
                                                                    <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                ) : (
                                                                    <p className="text-yellow-300">
                                                                        After payment your Wallet balance will be: <span>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                                    </p>
                                                                )}
                                                            </div>
                                                            {walletBalanceAmount < userData.pairAddonFee && (
                                                                <div className='mb-4 flex text-wrap justify-center'>
                                                                    <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Recharge Wallet</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    
                                                    <div className='mt-4 flex text-wrap justify-center'>
                                                        <p className='text-white'>Input 14 Characters Alphanumeric Pair ID (eg TU243AM5850150):</p>
                                                    </div>
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        <p className='text-white'>Ask your referrer to provide their Pair Code from Home {'->'} Profile {'->'} My Think5Whys Code</p>
                                                    </div>
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        <p className='text-white'>To apply their Code as Pair Code they must have purchased this Item / Book"</p>
                                                    </div>
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        <p className='text-yellow-200'>Your User Code {userCode}</p>
                                                    </div>
                                                    <div className="mb-4 flex justify-center">
                                                        <input
                                                        type="text"
                                                        name="pairCode"
                                                        id="pairCode"
                                                        value={pairCode}
                                                        placeholder="Input Pair Code"
                                                        onChange={(e) => setPairCode(e.target.value)}
                                                        className="h-12 text-center p-2 border border-gray-300"
                                                        />
                                                    </div>
                                                    <div className="mb-4 flex justify-center">
                                                        {error && <p className="text-red-800">{error}</p>}
                                                    </div>
                                                    <div className="flex justify-center">
                                                        <p className={pairCodeStatus ? "text-green-800" : "text-red-600"}>
                                                                {pairCodeStatusMsg}
                                                        </p>
                                                    </div>
                                                    <div className='mb-4 flex justify-center'>
                                                        <button
                                                            type="button"
                                                            className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                            onClick={() => { pairCodeValidationClicked(pairCode);}}
                                                            disabled={pairCodeStatus}
                                                        >
                                                            {pairCodeStatus ? "Pair Code Validated" : "Validate Pair Code"}
                                                        </button>
                                                    </div>
                                                    {pairCodeStatus && (
                                                        <>
                                                        <div className="flex justify-center">
                                                            <p className="text-white text-lg">Your Pair Name: <strong className="text-yellow-300 text-lg">{userPairName}</strong></p>
                                                        </div>
                                                        <div className='flex justify-center'>
                                                            <button
                                                                onClick={handleAddPairButtonClick}
                                                                disabled={buttonAddPairDisabled}
                                                                className='px-4 py-2 bg-orange-500 text-white rounded'
                                                            >
                                                                Confirm To Add {userPairName} as Pair for this Thinkletics Competition & Pay From Your Think5Whys Wallet
                                                            </button>
                                                        </div>
                                                        {addPairStatus && buttonAddPairDisabled && (
                                                            <>
                                                            <div className='flex justify-center'>
                                                                <p className='text-green-700'>You Pair with {userPairName} Created Successfully</p>
                                                            </div>
                                                            </>
                                                        )}
                                                        {!addPairStatus && buttonAddPairDisabled && (
                                                            <div className='flex justify-center'>
                                                                <p className='text-red-700'>You Pair with {userPairName} Not Created. Please Retry.</p>
                                                            </div>
                                                        )}
                                                </>
                                                    )}
                                                </div>
                                                </>
                                            )}
                                            </>
                                        ) : (
                                        <div className='mb-2'>
                                            <div className='flex justify-center'>
                                            <button
                                                onClick={handlePairRankButtonClick}
                                                disabled={buttonPairRankDisabled}
                                                className='px-4 py-2 bg-green-800 text-white rounded'
                                            >
                                                Click to View Your Pair Rank With {userData.userPairName} 
                                            </button>
                                            </div>
                                            {buttonPairRankDisabled && top20Pairs !== null && (
                                                <div>
                                                    <p className='text-2xl text-yellow-300'><strong>Your Pair Rank:</strong> {pairRank}</p>
                                                    <p><strong>Combined Total Points:</strong> {combinedTotalPoints}</p>
                                                    <div className='mt-2'>
                                                        <p className='text-xl mb-4'>Top 20 Pair Rank List</p>
                                                        <div className='overflow-x-auto'>
                                                        <table className='min-w-full bg-green-600'>
                                                            <thead>
                                                            <tr>
                                                                <th className='py-2'>Rank</th>
                                                                <th className='py-2'>User 1</th>
                                                                <th className='py-2'>User 2</th>
                                                                <th className='py-2'>Combined Points</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {top20Pairs.map((pair, index) => (
                                                                <tr key={index}>
                                                                <td className='py-2'>{index + 1}</td>
                                                                <td className='py-2'>{pair.userName1}</td>
                                                                <td className='py-2'>{pair.userName2}</td>
                                                                <td className='py-2'>{pair.combinedTotalPoints}</td>
                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        )}
                                    </div>

                                    <div className='mb-4'>
                                        {userData.userTeamCode === '' ? (
                                            <>
                                                <div className='flex justify-center'>
                                                    <button
                                                        type="button"
                                                        className="bg-yellow-700 text-white hover:bg-primary-dark"
                                                        onClick={handleCreateTeamButtonClick}
                                                        disabled={createTeamClicked || joinTeamClicked}
                                                    >
                                                        Create Your Team
                                                    </button>
                                                </div>
                                                
                                                {createTeamClicked && (
                                                    <div className="text-black bg-blue-400 rounded-lg shadow-lg mb-4 mt-4 ml-4 mr-4">
                                                        <div className='mt-2 mb-2 flex text-wrap justify-center'>
                                                            <p className='text-yellow-200'>Your Team Code {userNewTeamCode}</p>
                                                        </div>
                                                        <div className="mb-4 flex justify-center">
                                                                <input
                                                                    type="text"
                                                                    name="newTeamName"
                                                                    id="newTeamName"
                                                                    value={newTeamName}
                                                                    placeholder="Input Your Team Name To Create"
                                                                    onChange={(e) => setNewTeamName(e.target.value)}
                                                                    className="h-12 text-center p-2 border border-gray-300"
                                                                />
                                                        </div>
                                                        <div className="mb-4 flex justify-center">
                                                            {error && <p className="text-red-800">{error}</p>}
                                                        </div>
                                                        <div className="flex justify-center">
                                                            <p className={teamCreationStatus ? "text-green-800" : "text-red-600"}>
                                                                {teamCreationStatus}
                                                            </p>
                                                        </div>
                                                        
                                                        <div className='mb-4 flex justify-center'>
                                                            <div className='flex justify-center'>
                                                                <button
                                                                    type="button"
                                                                    className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                                    onClick={() => { teamCreationValidationButtonClicked(userNewTeamCode, newTeamName, userId, eventId); }}
                                                                    disabled={addNewTeamStatus}
                                                                >
                                                                {addNewTeamStatus ? "Your Thinkletics Competition Team Is Created" : "Create Your Above Thinkletics Competition Team"}
                                                                </button>
                                                            </div>
                                                            {addNewTeamStatus && ( 
                                                                <div className='flex justify-center'>
                                                                    <p className={addNewTeamStatus ? "text-green-800" : "text-red-600"}>
                                                                    {addNewTeamStatusMsg}
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className='flex justify-center'>
                                                    <button
                                                        type="button"
                                                        className="bg-yellow-700 text-white hover:bg-primary-dark"
                                                        onClick={handleJoinTeamClick}
                                                        disabled={createTeamClicked || joinTeamClicked}
                                                    >
                                                        Join A Team
                                                    </button>
                                                </div>
                                                {joinTeamClicked && (
                                                    <div className="text-black bg-blue-400 rounded-lg shadow-lg mt-4 mb-4 mr-4 ml-4">
                                                        {teamMemberAddonFee>0 && (    
                                                            <div className="mt-4 mb-2">
                                                                <div className='flex justify-center'>
                                                                    <p  className='text-orange-800'>Member Joining Fee to pay: <span>₹{paymentAmount.toFixed(2)}</span></p>
                                                                </div>
                                                                <div className='flex justify-center'>
                                                                    <p className='text-orange-800'>Think5Whys Wallet Balance: <span>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                                </div>
                                                                <div className="flex justify-center">
                                                                    {paymentAmount > walletBalanceAmount ? (
                                                                        <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                                    ) : (
                                                                        <p className="text-yellow-300">
                                                                            After payment your Wallet balance will be: ₹{(walletBalanceAmount - paymentAmount).toFixed(2)}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                                {walletBalanceAmount < teamMemberAddonFee && (
                                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                                        <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Recharge Wallet</button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        <div className='mt-4 flex text-wrap justify-center'>
                                                            <p className='text-white'>Input 14 Characters Alphanumeric Team ID (eg TL243AM5850150):</p>
                                                        </div>
                                                        <div className='mb-4 flex text-wrap justify-center'>
                                                            <p className='text-white'>Ask the Team Creator to provide Thinkletics Team ID</p>
                                                        </div>
                                                        <div className='mb-4 flex text-wrap justify-center'>
                                                            <p className='text-yellow-200'>{userTeamCode=='' ? "You have not created any team nor have joined any team" : userTeamCode}</p>
                                                        </div>
                                                        <div className="mb-4 flex justify-center">
                                                            <input
                                                                type="text"
                                                                name="teamCode"
                                                                id="teamCode"
                                                                value={teamCode}
                                                                placeholder="Input Team Code"
                                                                onChange={(e) => setTeamCode(e.target.value)}
                                                                className="h-12 text-center p-2 border border-gray-300"
                                                            />
                                                        </div>
                                                        <div className="flex justify-center">
                                                            {error && <p className="text-red-800">{error}</p>}
                                                        </div>
                                                        <div className="flex justify-center">
                                                            <p className={teamCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                                                                {teamCodeStatusMsg}
                                                            </p>
                                                        </div>
                                                        <div className='flex justify-center'>
                                                            <button
                                                                type="button"
                                                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                                onClick={() => { teamCodeValidationClicked(teamCode, userData.eventId) }}
                                                                disabled={teamCodeStatus}
                                                            >
                                                                {teamCodeStatus ? "Team Code Validated" : "Validate Team Code"}
                                                            </button>
                                                        </div>
                                                        {teamCodeStatus && (
                                                            <>
                                                               <div className='flex justify-center'>
                                                                    <button
                                                                        onClick={handleJoinTeamButtonClick}
                                                                        disabled={buttonJoinTeamDisabled}
                                                                        className='px-4 py-2 bg-orange-500 text-white rounded'
                                                                    >
                                                                        Confirm To Join in The {userTeamName} for this Thinkletics Competition & Pay From Your Think5Whys Wallet
                                                                    </button>
                                                                </div>
                                                                {joinTeamStatus && buttonJoinTeamDisabled && (
                                                                    <div className='flex justify-center mb-4'>
                                                                        <p className='text-green-800 text-lg'>Now you have joined the Team {userTeamName} Successfully</p>
                                                                    </div>
                                                                )}
                                                                {!joinTeamStatus && buttonJoinTeamDisabled && (
                                                                    <div className='flex justify-center'>
                                                                        <p className='text-red-600'>You Team {userTeamName} Not Created. Please Retry.</p>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className='mt-2'>
                                                <div className='flex justify-center'>
                                                <button
                                                    onClick={handleTeamRankButtonClick}
                                                    disabled={buttonTeamRankDisabled || userData.teamMemberCount<3}
                                                    className='px-4 py-2 bg-green-800 text-white rounded'
                                                >
                                                    Click to View Rank For The Team {userData.userTeamName}
                                                </button>
                                                </div>
                                                { userData.teamMemberCount<3 &&(
                                                    <div className='flex justify-center'>
                                                        <p className='text-lg items-center'>This Team Require At Least 3 Team Members To Start Getting Ranked In The Competions Ranking. Currently it has {userData.teamMemberCount} members.</p>
                                                    </div>
                                                )}
                                                {buttonTeamRankDisabled && top20Teams !== null && (
                                                    <div>
                                                        <p><strong>Team Rank:</strong> {teamRank}</p>
                                                        <div className='mt-4'>
                                                            <p className='text-xl mb-4'>Top 20 Team Rank List</p>
                                                            <div className='overflow-x-auto'>
                                                                <table className='min-w-full bg-blue-600'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className='py-2'>Rank</th>
                                                                            <th className='py-2'>Team Code</th>
                                                                            <th className='py-2'>Team Name</th>
                                                                            <th className='py-2'>Total Points</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {top20Teams.map((team, index) => (
                                                                            <tr key={index}>
                                                                                <td className='py-2'>{index + 1}</td>
                                                                                <td className='py-2'>{team.userTeamCode}</td>
                                                                                <td className='py-2'>{team.userTeamName}</td>
                                                                                <td className='py-2'>{team.totalPoints}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        )}
                                    </div>

                                    <div className='mb-4'>  
                                        <div className='flex justify-center'>                                    
                                            <p><strong>Total Number of Assignments Completed:</strong> {userData.assignmentCount}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                            <p><strong>Assignment Points Earned:</strong> {userData.assignmentPoints}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                            <p><strong>Assignment Remarks:</strong> {userData.assignmentRemarks}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                        <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                                <Link to="/assignments-think5whys">Go To DIY Assignments</Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='mb-4'>
                                        <div className='flex justify-center'>                                    
                                            <p><strong>Total MCQ Practiced:</strong> {userData.practiceMCQCount}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                            <p><strong>MCQ Practice Points Earned:</strong> {userData.practiceMCQPoints}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                            <p><strong>Remarks:</strong> {userData.practiceMCQRemarks}</p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                        <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                                <Link to="/practice-mcq">Go To Practicing MCQ Test Series for Think5Whys Certification</Link>
                                            </p>
                                        </div>
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Certificate Number:</strong> {userData.certificateNumber}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Certificate Date:</strong> {userData.certificateDate ? formattedDateTime(userData.certificateDate) : ""}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.certificationTestRemarks}</p>
                                    </div>
                                    {userData.certificateNumber === '' && (
                                        <>
                                        <div className='flex justify-center'>                                    
                                            <button
                                                    onClick={handleUpdateCertificateInfoClick}
                                                    className='px-4 py-2 bg-green-800 text-white rounded'
                                            >
                                                Update Certificate Details
                                            </button>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                        <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                                <Link to="/certification-test-think5whys">Start Think5Whys Certification Test</Link>
                                            </p>
                                        </div> 
                                        </>
                                    )}
                                </div>
                                {userData.totalPoints >=200 ? (
                                    <div className='mb-4'>
                                        <div className='flex justify-center'>                                    
                                            <p>
                                                <strong className='text-green-800'>Your Competition Started</strong> 
                                                On  <strong className='ml-4'>{userData.thinkleticsMasterCode}</strong>
                                            </p>
                                        </div>
                                        <div className='flex justify-center'>                                    
                                            <p>
                                                <strong>Your Competions Badge Number:</strong>{userData.registrationNumber} 
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className='flex justify-center'>
                                            <p className='text-yellow-200 text-2xl'>
                                                <strong >Your Competition Has Not Started Yet!!</strong> 
                                            </p>
                                        </div>
                                        <div className='flex justify-center'>    
                                            <p className='text-white'>
                                                <strong>Complete All The Above Stages With 200 Points or More To Qualify for the Competition. Your Current Total Points Are {userData.totalPoints}</strong>
                                            </p>
                                        </div>
                                    </div>
                                )}
                                {userData.registrationRemarks.trim() !== "" && (
                                    <div className='mb-4'>
                                        <p><strong>Remarks:</strong> {userData.registrationRemarks}</p>
                                    </div>
                                )}
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>RCA Entry Count:</strong> {userData.rcaEntryCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Total RCA Points:</strong> {userData.rcaEntryPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.rcaEntryRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/rcas/add">Do More RCAs</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>LC Entry Count:</strong> {userData.lcEntryCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Total LC Points:</strong> {userData.lcEntryPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.lcEntryRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/tasks/add">Continue Managing Life Chronicles</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Number of Life Chronicles You Have Done RCA For:</strong> {userData.rcaLCLinkEntryCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Total Points Earned:</strong> {userData.rcaLCLinkEntryPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.rcaLCLinkEntryRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/life-chronicles-home">Do RCA of More Life Chronicles </Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Think5Whys Book Page Read Count:</strong> {userData.bookPageReadCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Book Page Read Points:</strong> {userData.bookPageReadPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.bookPageReadRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/bookshelf">Read Think5Whys Book</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>SpotSnap Count:</strong> {userData.spotSnapCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>SpotSnap Points Earned:</strong> {userData.spotSnapPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.spotSnapRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/spotsnap">Go To SpotSnap</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Focus Timer Count:</strong> {userData.focusTimerCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Focus Timer Points Earned:</strong> {userData.focusTimerPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.focusTimerRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/focus-timer-start">Go To FocusTimer</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>More Book Buy Count:</strong> {userData.bookBuyCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Book Buy Points Earned:</strong> {userData.bookBuyPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.bookBuyRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/bookworld">Buy More Exciting Titles On Think5Whys BookStore</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Book Gifting Count:</strong> {userData.bookGiftingCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Book Gifting Points Earned:</strong> {userData.bookGiftingPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.bookGiftingRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/bookworld">There is no limit of Joy of Gifting. Keep Gifting</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>VisualBrief Presentation Count:</strong> {userData.vbEntryCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>VisualBrief Presentation Points Earned:</strong> {userData.vbEntryPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.vbEntryRemarks}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                    <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                    <Link to="/visualbrief-home">Go to Visual Brief</Link>
                                        </p>
                                    </div> 
                                </div>
                                <div className='mb-4'>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>POVify Count:</strong> {userData.povifyEntryCount}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>POVify Points Earned:</strong> {userData.povifyEntryPoints}</p>
                                    </div>
                                    <div className='flex justify-center'>                                    
                                        <p><strong>Remarks:</strong> {userData.povifyEntryRemarks}</p>
                                    </div>
                                   <div className='flex justify-center'>                                    
                                        <p className='bg-yellow-700 text-white text-center py-2 mb-4 ml-4 mr-4 w-full'>
                                            <Link to="/povify-home">Go to POVify. Write Your Own Point of View (POV).</Link>
                                        </p>
                                    </div> 
                                </div>
                                {userData.remarks && userData.remarks.trim() !== "" && (
                                    <div className='mb-4 flex justify-center'>
                                        <p className='text-yellow-200 text-xl'>{userData.remarks}</p>
                                    </div>
                                )}
                                <div className='flex justify-center'>                                    
                                    <button
                                            onClick={handleNavigateToThinkleticsDataSyncClick}
                                            className='px-4 py-2 bg-yellow-300 text-blue-800 rounded'
                                    >
                                        Keep Your Points Table Up-to-date. Click here to Sync and Update
                                    </button>
                                </div>
                            </div>
                            )}
                        </>
                    ) : (
                        <div>
                            <p className="mb-4 text-xl text-yellow-400 text-center">You have not purchased The Think5whys - Book 1 Main BOK (Body of Knowledge Book) yet To Participate In Thinkletics Championships.</p>
                            <p className="mb-4 text-xl text-center">
                                <Link to="/bookworld" className="mb-4 text-xl bg-yellow-600 text-white text-center">
                                    Buy <strong>Think5whys - Book 1 Main BOK (Body of Knowledge Book)</strong> Now
                                </Link>
                            </p>
                        </div>
                    )}
                </>
            )}
        </div>
    </MainLayout>
);
};

export default ThinkleticsDashboard;

